module.exports = __webpack_public_path__ + "img/user-black.ac63657e.svg";